import { z } from 'zod';

export const UserRole = z.enum(['technician', 'supervisor', 'admin']);
export type UserRole = z.infer<typeof UserRole>;

export const UserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string().min(1),
  role: UserRole,
  crewId: z.string().uuid().nullable(),
  location: z.string().nullable(),
  skills: z.array(z.string()),
  certifications: z.array(
    z.object({
      name: z.string(),
      expiresAt: z.string().datetime().nullable(),
    }),
  ),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  // External identity
  masOrgId: z.string().nullable().optional(),
  masSiteId: z.string().nullable().optional(),
  externalSystem: z.string().nullable().optional(),
  externalId: z.string().nullable().optional(),
  externalRefId: z.string().nullable().optional(),
});

export type User = z.infer<typeof UserSchema>;
